module.exports = __webpack_public_path__ + "img/maersk.e567a2eb.webp";